/**
 * carga automatica de Modulos
 * deben comenzar con la palabra 'modulo' y terminar con la palabra 'Store', ademas de tener
 * la extension .js (se debe respetar el nombre CaseSensitive.
 * el nombre del modulo sera el nombre del archivo sin las palabras 'modulo' ni 'Store'
 * ej: nombre del archivo 'moduloUsuariosStore.js' -> nombre modulo 'Usuarios'
 */
export default function loadOldStoreModules() {
  const files = require.context('../../febos/', true, /modulo.*(Store\.js)$/);

  return files.keys().reduce((index, file) => {
    const fileName = file.split('/').pop().replace('Store.js', '').replace('modulo', '');

    const moduleBase = files(file);
    const moduleSettings = {
      ...(moduleBase.default || moduleBase)
    };

    return {
      ...index,
      [fileName]: moduleSettings
    };
  }, {});
}
